import { supabase } from '../utils/supabaseClient'

interface PersonYellowCards {
    id: number;
    count: number;
}

const fetchPersonYellowCards = async (id: number): Promise<PersonYellowCards> => {
    try {
        console.log(`Fetching person yellow cards data for ID: ${id}...`);
        // Step 1: Fetch Person Yellow Cards Data
        const { data: yellowCardsData, error: yellowCardsError } = await supabase
            .from('player_yellow_cards')
            .select('id, count')
            .eq('id', id)
            .single();

        if (yellowCardsError && yellowCardsError.code !== 'PGRST116') {
            // PGRST116 is the error code for "Results contain 0 rows"
            console.error('Person Error:', yellowCardsError);
            throw yellowCardsError;
        }

        if (!yellowCardsData) {
            console.log(`No yellow cards data found for player with ID: ${id}. Returning 0.`);
            return { id, count: 0 };
        }

        console.log('Person yellow cards:', yellowCardsData);

        return yellowCardsData as PersonYellowCards;
    } catch (error) {
        console.error('Error fetching player yellow cards:', error);
        throw error;
    }
}

export default fetchPersonYellowCards;